<div *ngIf="loader" class="banner-overlay" [ngClass]="{'hide-overlay': pageLoaded}">
    <h1 *ngIf="screenWidth >= 768" class="heading1 font-bold heading-1-m f-black" [ngClass]="{'loader-text': loadText}">
        <p>Art</p>
        <p>meets science.</p>
    </h1>
    <h1 *ngIf="screenWidth < 767" class="heading1 font-bold heading-1-m f-black" [ngClass]="{'loader-text': loadText}">
        <p>Art</p>
        <p>meets</p>
        <p>science.</p>
    </h1>
</div>